import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, map } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DenunciasService {

  constructor(private http: HttpClient) { }


  guardarDenuncia(data:any):Observable<any>{
    const headers = {'Content-type':'Aplicattion/json'};
    const body = JSON.stringify(data);
    return this.http.post(`${environment.API_DOMAINS.servicios}/denuncias/guardarDenuncia`,body, { headers })
  }
  
  obtenerPropiedadesDenuncias():Observable<any>{
    return this.http.get(`${environment.API_DOMAINS.servicios}/propiedad/listarPropiedad`);
  }
  
  buscarDenuncia(filtros:any):Observable<any>{
    const headers = {'Content-type':'Aplicattion/json'};
    const body = JSON.stringify(filtros);
    return this.http.post(`${environment.API_DOMAINS.servicios}/denuncias/obtenerDenuncia`,filtros)
      //transformar Query DB
      .pipe(map((res:any) => {
        return {
          id:res.den_codigo,
          fechaIngreso:res.den_fecha_ingreso,
          fechaResolucion:res.res_fecha_resolucion,
          estado:res.est_nombre,
          documentacionAnexa: res.totalDocu, 
          anonimo : res.den_anonimo
        }
      }));
  }

  obtenerCorrelativo(){
    return this.http.get(`${environment.API_DOMAINS.servicios}/denuncias/obtenerCorrelativo`);
  }

  obtenerDenuncia(data: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = { 'Content-Type': 'application/x-www-form-urlencoded' };
    return this.http.post(`${environment.API_DOMAINS.servicios}/denuncias/obtenerDenunciaFiscal`, body, { headers });
  }

  listarEstados(): Observable<any> {
    return this.http.get(`${environment.API_DOMAINS.servicios}/denuncias/listarEstados`);
  }

  getSignedUrl(data: any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = {'Content-Type': 'application/x-www-form-urlencoded'};
    return this.http.post(`${environment.API_DOMAINS.servicios}/getSignedUrl`, body, {headers});
  }

  listarInvolucran (): Observable<any> {
    return this.http.get(`${environment.API_DOMAINS.servicios}/denuncias/listarInvolucran`);
  }
  
}
